import { EventBus } from '@/modules/plugins/modules/event'
const scrollBehavior = function (to, from, savedPosition) {
    return new Promise((resolve) => {
        const position = savedPosition || {}
        if (to.hash) {
            position.selector = to.hash
        }
        if (!savedPosition) {
            position.x = 0
            position.y = 0
        }
        EventBus.$once('finally', () => {
            setTimeout(() => {
                resolve(position)
            }, 400)
        })
    })
}

export default scrollBehavior
